import JobData from "@/http/data/job-data";
import ErrorData from "@/http/data/error-data";
import {JobOverviewDisplayValue} from "@/types/strings";
import {DatePeriod} from "@/types/date-period";

export default class JobState {
    collapsedJobAccordionItem = "concierge";
    httpError: null|ErrorData = null;
    isInitialized = false;
    jobOverviewJobPeriod: DatePeriod = [null, null];
    jobOverviewDisplay: JobOverviewDisplayValue = "all";
    jobs: JobData[] = [];
    unitOverviewJobPeriod: DatePeriod = [null, null];
    selectedNewJobContractId: null|string = null;
    selectedNewJobType = "";
    selectedNewJobUnitCheckTodoResultId: null|number = null;
}
